import style from './NotePreferences.module.scss';
import InfoModal from '@/components/InfoModal/index.tsx';
import { useState } from 'react';
import styles from '@/modules/NotePreferences/NotePreferences.module.scss';
import infoIcon from '@image/info-icon.svg';

const NotePreferenceCheckbox = (props: {
  title: string;
  isHeading: boolean;
  attributeName: string;
  value: boolean;
  onValueChanged: (a: string, b: boolean) => void;
  disabled?: boolean;
  hint?: { title: string; content: { title: string; value: string }[] };
  analyticsProperties?: { preferenceType: string; noteSection: string };
}) => {
  const [isPreferencesModalOpen, setIsPreferencesModalOpen] = useState(false);

  return (
    <div className={style.checkbox__container}>
      <InfoModal
        modalOpen={isPreferencesModalOpen}
        modalClose={() => setIsPreferencesModalOpen(false)}
        content={props.hint}
        analyticsProperties={props.analyticsProperties}
      />

      <div className={styles.select__label}>
        <label className={props.isHeading ? `${style.checkbox__label__heading}` : ''}>
          {props.title}
        </label>
        {props.hint && (
          <img
            className={styles.info__icon}
            onClick={() => setIsPreferencesModalOpen(true)}
            src={infoIcon}
            alt="info"
          />
        )}
      </div>

      <label className={style.checkbox__label__container}>
        <input
          type="checkbox"
          checked={props.value}
          onChange={(e) => props.onValueChanged(props.attributeName, e.target.checked)}
        />
        <span className={style.checkmark}></span>
      </label>
    </div>
  );
};

export default NotePreferenceCheckbox;
